import { render } from "./FilterAside.vue?vue&type=template&id=a5b8235a"
import script from "./FilterAside.vue?vue&type=script&lang=js"
export * from "./FilterAside.vue?vue&type=script&lang=js"

import "./FilterAside.vue?vue&type=style&index=0&id=a5b8235a&lang=scss"
script.render = render

export default script